// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setAxisExtremes = createAction('[Scatter Plot] Set Axis Extremes', props());
